// extracted by mini-css-extract-plugin
export default {"table_box":"IGameRewardTable_table_box__HdyOg","table_title":"IGameRewardTable_table_title__hQ3FG","m":"IGameRewardTable_m__kJ1Jw"};